import { FC } from 'react';
import { Zap } from 'lucide-react';

interface FrequencyDisplayProps {
    value: number | string | undefined;
}

/**
 * Professional data-chip style frequency display
 * Creative but enterprise-grade look
 */
export const FrequencyDisplay: FC<FrequencyDisplayProps> = ({ value }) => {
    const posts = typeof value === 'number'
        ? value
        : typeof value === 'string'
            ? parseFloat(value)
            : null;

    if (posts === null || isNaN(posts)) {
        return (
            <span className="text-sm text-gray-400 font-medium">N/A</span>
        );
    }

    const roundedPosts = Math.round(posts);

    return (
        <div className="flex items-center gap-2 group w-fit">
            {/* Icon Container - looks like a small technical tile */}
            <div className="flex items-center justify-center w-7 h-7 rounded-md bg-white border border-gray-200 group-hover:border-blue-300 group-hover:bg-blue-50 transition-all duration-200">
                <Zap className="w-3.5 h-3.5 text-gray-400 group-hover:text-blue-500 transition-colors" />
            </div>

            {/* Text Container */}
            <div className="flex flex-col leading-[1.1]">
                <div className="flex items-baseline gap-1">
                    <span className="text-sm font-bold text-gray-900 tabular-nums">
                        {roundedPosts}
                    </span>
                    <span className="text-[11px] font-semibold text-gray-500">
                        Posts
                    </span>
                </div>
                <span className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">
                    Weekly Avg
                </span>
            </div>
        </div>
    );
};
